import { Director, director, EventKeyboard, Input, input, instantiate, KeyCode, Prefab, Scene } from 'cc';
import Game from '../../Game';
import BundleAssetProvider, { TaskNamingHelper } from '../../BundleAssetProvider';
import IPreloader from '../../IPreloader';
import ToolBar from './ToolBar';
import BaseTool from './BaseTool';
import LoadingTask from '../Helper/Loading/LoadingTask/LoadingTask';
import { LoadingType } from '../../Config/AssetLoadingConfigType';

export type ShaderDefineMap = { [name: string]: { type: string | number | boolean } };

const COMMON_BUNDLE_NAME = 'common';
const TOOL_BAR_PREFAB_KEY = 'toolBar';

class ToolManager implements IPreloader {
    private _loadingTask: LoadingTask = null;
    private _assetProvider: BundleAssetProvider = null;
    private _toolBarPrefab: Prefab = null;
    private _toolBar: ToolBar = null;

    constructor() {
        this._assetProvider = new BundleAssetProvider({
            bundleName: COMMON_BUNDLE_NAME,
            path: {
                prefab: {
                    [TOOL_BAR_PREFAB_KEY]: 'ToolBar/ToolBar',
                },
            },
        });
        input.on(Input.EventType.KEY_DOWN, (e: EventKeyboard) => {
            if (e.keyCode === KeyCode.KEY_D) {
                this.toggleDisplay(!this.isVisible);
            }
        });
    }

    public get isVisible(): boolean {
        return this._toolBar?.isVisible ?? false;
    }

    public preload() {
        if (!this._loadingTask) {
            this._loadingTask = Game.config.debug
                ? new LoadingTask(
                      TaskNamingHelper.concatTaskName({
                          loadingType: LoadingType.PRELOAD,
                          providerName: this._assetProvider.name,
                          configName: this._assetProvider.assetLoadingConfigs[0].name,
                      }),
                      this._assetProvider.load(TOOL_BAR_PREFAB_KEY, Prefab).then((prefab) => this._onToolBarPrefabLoaded(prefab)),
                  )
                : LoadingTask.Success;
        }
        return this._loadingTask;
    }

    public addTool(tool: BaseTool) {
        if (!this._toolBar) {
            return;
        }
        this._toolBar.addTool(tool);
    }

    public toggleDisplay(flag: boolean) {
        if (!this._toolBar) {
            return;
        }
        this._toolBar.toggleDisplay(flag);
    }

    private _onToolBarPrefabLoaded(prefab: Prefab) {
        this._toolBarPrefab = prefab;
        director.on(Director.EVENT_BEFORE_SCENE_LAUNCH, (scene: Scene) => {
            if (scene.name.includes('Game')) {
                this._addToolBarToScene(scene);
            }
        });
    }

    private _addToolBarToScene(scene: Scene) {
        this._toolBar = instantiate(this._toolBarPrefab).getComponent(ToolBar);
        scene.getChildByName('Canvas').addChild(this._toolBar.node);
    }
}

const toolManager = new ToolManager();

export default toolManager;
